<template>
  <div class="relative overflow-hidden">
    <!-- <div class="l:hidden flex-wrap gap-l">
      <saffron-link v-for="link in sideNavLinks" :key="link.label" :to="link.action.data">
        <form-button :icon="link.icon">{{ link.label }}</form-button>
      </saffron-link>
    </div> -->
    <div
      class="main-category-wrapper container container-xl flex-wrap flex-center margin-max-vertical">
      <div class="flex-column flex-middle gap-m l:hidden">
        <form-button
          v-if="!mobileMenuExpanded"
          class="flex-middle gap-s cursor-pointer l:hidden"
          theme="lead-inverse"
          icon-end="chevron-inline-end"
          @click="mobileMenuExpanded = !mobileMenuExpanded">
          {{ t("justopp.productCategories.mobileCategoryListCta") }}
        </form-button>
        <form-button
          v-if="mobileMenuExpanded"
          class="flex-middle gap-s cursor-pointer l:hidden"
          theme="lead-inverse"
          icon-end="chevron-down"
          @click="mobileMenuExpanded = !mobileMenuExpanded">
          {{ t("justopp.productCategories.mobileCategoryListCtaClose") }}
        </form-button>
        <div
          v-show="mobileMenuExpanded"
          class="mobile-nav-container margin-m-top overflow-hidden animate__fadeIn animate--fast">
          <base-side-nav
            v-if="sideNavLinks"
            class="mobile-nav l:hidden"
            :items="sideNavLinks"></base-side-nav>
        </div>
      </div>
      <div class="width-expand  m:flex-between flex-center gap-xl">
        <base-side-nav
          v-if="sideNavLinks"
          class="side-nav l:visible max-width-250"
          :items="sideNavLinks"></base-side-nav>
        <div class="categories-inner width-expand flex-wrap m:flex-between flex-center gap-xl">
          <div
            v-for="category in finalCategories"
            :key="category.id"
            class="master-category-item flex-between flex-stretch relative">
            <div class="content-block padding-m-horizontal padding-l-top padding-xl-bottom">
              <div class="content-inner text-center">
                <h3 class="text-center margin-remove">
                  {{ category.name }}
                </h3>
                <span class="sub-category-count">
                {{
                    translateUcFirst("justopp.category.productCount", {
                      count: category.productCount,
                    })
                  }}
              </span>
                <div class="category-title-separator margin-l-top margin-l-bottom" />
                <content-blocks
                  class="category-intro"
                  :content="category.intro"></content-blocks>
                <div class="cta-container margin-top-auto">
                  <!-- TODO link to deal search deep link -->
                  <div class="flex">
                    <form-button
                      theme="text"
                      text="justopp.productCategories.browseCategoryCta">
                    </form-button>
                </div>
                  <saffron-link
                    class="plain-link absolute-cover z-level-1"
                    :to="{
                    name: 'store-categories-cid-deals',
                    params: { cid: category.id },
                  }">
                  </saffron-link>
                </div>
              </div>
            </div>
            <div class="media-block relative">
              <div
                class="absolute-cover background-cover"
                :style="`background-image: url('${category.introImage}');`"></div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import BaseSideNav from "@/client/components/nav/BaseSideNav.vue";
import { computed } from "vue";

export default {
  components: { BaseSideNav },
  layout: {
    component: "noContainer",
    params: {
      title: "justopp.productCategories.pageTitle",
      subTitle: "justopp.productCategories.pageSubtitle",
    },
  },
  middleware: {},
  props: {},
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();

    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "justopp.productCategories.browserTitle",
  data() {
    return {
      mobileMenuExpanded: false,
      rootLevel: 1,
      rawCategories: [],
      asyncData: {
        rawCategories: {
          target: "justopp/categories",
          data: {
            ordering: { key: "order", direction: "asc" },
            filters: {
              type: "products",
              level: computed(() => this.rootLevel), // "first" level categories
              country: computed( () => {
                let userProfile = this.sg('user.profile');
                if (!userProfile?.isSuperAdmin && ! userProfile?.Vendor) {
                  return this.sg('user.profile')?.country
                }
                return undefined;
              }),
              //  anyChildOf: 14, // only product categories
            },
            with: ["productCount"],
          },
        },
      },
    };
  },
  computed: {
    finalCategories() {
      if (!this?.rawCategories?.items || this?.rawCategories?.items?.length < 1) {
        return [];
      }
      if (this?.rawCategories?.items) {
        return this?.rawCategories?.items;
      }

      return [];
    },

    sideNavLinks() {
      return [
        { action: { type: "title" }, label: "Categories" },
        ...this.finalCategories.map((category) => ({
          action: {
            type: "routerNavigation",
            data: {
              to: { name: "store-categories-cid-deals", params: { cid: category.id } },
            },
          },
          icon: this.nameToSvg(category.name),
          label: category.name,
        })),
      ];
    },
    pillNavLinks() {
      return this.finalCategories.map((category) => ({
        target: "#",
        label: category.name,
      }));
    },
  },
  watch: {},
  methods: {
    nameToSvg(name) {
      return name.replace(/\s+/g, "-").toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.main-category-wrapper {
  gap: var(--margin-max);

  @media (max-width: 767px) {
    gap: var(--margin-2xl);
  }
}
.master-category-item {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  margin-bottom: var(--margin-2xl);
  overflow: hidden;
  flex: 0 0 300px;
  flex-direction: column;
  border: 1px solid var(--c-gray-2);
  border-radius: var(--border-radius-s);
  transition: 200ms ease;

  &:hover {
    transform: scale(1.02, 1.02);
    box-shadow: var(--box-shadow-3);
    z-index: var(--z-level-2);
    border: 1px solid var(--c-gray-3);
  }

  .content-block {
    order: 2;
    border: 1px solid var(--c-gray-2);
    background-color: var(--c-gray-1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: var(--margin-2xl);
    flex-grow: 4;

    @media (max-width: 1024px) {
      border: none;
    }

    .content-inner {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 100%;
      min-height: 150px;

      @media (max-width: 1024px) {
        max-width: 100%;
        min-width: 0;
      }
    }

    .category-title-separator {
      width: 150px;
      flex: 0 0 1px;
      min-height: 1px;
      background: var(--c-gray-3);
    }

    .sub-category-count {
      color: var(--c-gray-4);
      font-size: var(--font-s);
      margin-top: var(--margin-s);
    }

    .cta-container {
      display: flex;
      margin-inline-start: auto;
      margin-inline-end: auto;
      margin-top: auto;
      justify-content: center;
      padding-top: var(--margin-xl);
    }

    .category-content {
      text-align: start;
      margin-top: auto;
      align-self: flex-end;
    }
  }

  .media-block {
    order: 0;
    width: 100%;
    height: 200px;
    flex: 0 0 200px;

    @media (max-width: 1024px) {
      box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.5);
    }
  }
}

.category-intro {
  height: auto;
  overflow: hidden;
}
.side-nav {
  //position: absolute;
  // top: var(--margin-max);
  // width: 250px;

  @media (max-width: 1024px) {
    top: auto;
    position: relative;
    width: auto;
    overflow: hidden;
  }
}

.mobile-nav-container {
  display: grid;
  transition: grid-template-rows 800ms;
  margin-bottom: calc(var(--margin-l) * -1);
  // margin-bottom: calc(var(--margin-l) * -1);
}

.hide {
  grid-template-rows: 0fr;
}

.show {
  grid-template-rows: 1fr;
}

.flip {
  transform: rotateZ(-180deg);
  animation: fader 150ms;
}

.normal {
  animation: also-fader 150ms;
}

@keyframes fader {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes also-fader {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.flippable {
  transition-delay: 0.75ms;
  transition-property: transform;
  transition-duration: 0ms;
}

.menu-indicator {
  background-color: var(--c-lead) !important;

  &:hover {
    background-color: var(--c-bg) !important;
  }
}
</style>
